import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import modalReducer from './redux/reducers/modalReducer';
import homeReducer from './redux/reducers/homeReducer';
import sideBarReducer from './redux/reducers/sideBarReducer';
import fabricCanvasReducer from './redux/reducers/fabricCanvasReducer';
import finalCheckReducer from './redux/reducers/finalCheckReducer';
import pageControllerReducer from './redux/reducers/pageControllerReducer';
import vanillaDesignReducer from './redux/reducers/vanillaDesignReducer';
import stickerReducer from './redux/reducers/stickerReducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // This is added for debugging purpose using Redux Dev tools

const combinedStore = createStore(
  combineReducers({
    modal: modalReducer,
    home: homeReducer,
    sideBar: sideBarReducer,
    fabricCanvas: fabricCanvasReducer,
    finalCheck: finalCheckReducer,
    pageController: pageControllerReducer,
    vanilla: vanillaDesignReducer,
    sticker: stickerReducer
  }),
  composeEnhancers(applyMiddleware(thunk)) // Thunk : Middleware used for Asynchronous redux state updates
);

export default combinedStore;
